import apiClient from '../lib/apiClient';

const cleanBase64 = (input = '') => {
  if (!input) return '';
  if (!input.includes(',')) return input;
  return input.split(',')[1] || '';
};

const removeBgService = {
  async fromUrl(imageUrl) {
    const data = await apiClient.request('/remove-bg', {
      method: 'POST',
      body: JSON.stringify({ image_url: imageUrl }),
      auth: false,
    });

    return {
      success: Boolean(data?.success && data?.image_data_url),
      image_data_url: data?.image_data_url || '',
      message: data?.message || 'Não foi possível remover o fundo da imagem',
    };
  },

  async fromDataUrl(dataUrl) {
    const base64 = cleanBase64(dataUrl);
    const data = await apiClient.request('/remove-bg', {
      method: 'POST',
      body: JSON.stringify({ image_base64: base64 }),
      auth: false,
    });

    return {
      success: Boolean(data?.success && data?.image_data_url),
      image_data_url: data?.image_data_url || '',
      message: data?.message || 'Não foi possível remover o fundo da imagem',
    };
  },
};

export default removeBgService;
